import { render, staticRenderFns } from "./national_finals_reportSignIn.vue?vue&type=template&id=1963ff20&scoped=true&"
import script from "./national_finals_reportSignIn.vue?vue&type=script&lang=js&"
export * from "./national_finals_reportSignIn.vue?vue&type=script&lang=js&"
import style0 from "./national_finals_reportSignIn.vue?vue&type=style&index=0&id=1963ff20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1963ff20",
  null
  
)

export default component.exports